import { render, staticRenderFns } from "./EmailActivation.vue?vue&type=template&id=b509d0c0"
import script from "./EmailActivation.vue?vue&type=script&lang=js"
export * from "./EmailActivation.vue?vue&type=script&lang=js"
import style0 from "./EmailActivation.vue?vue&type=style&index=0&id=b509d0c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports